<!-- 帮助中心 赵禹 2018年1月23日19:59:48 -->
<template>
  <div class="help-content">
    <div id="help2_wh">
      <ul>
        <li class="help_img">
          <a @click.stop.prevent="cSideBar(7)"><img
              src="//static.kxymall.com/images/bzzx.jpg"
              alt="帮助中心图标"
            /></a>
        </li>
        <li class="help_li1"><span>关于网站</span></li>
        <!-- 调用CMS数据搜索标签，并传递所在模型ID参数 -->
        <li>
          <span class="help_spans">
            <a
              @click.stop.prevent="cSideBar(7)"
              :class="{'active': articleid === 7}"
            >关于我们</a>
          </span>
        </li>
        <li>
          <span class="help_spans">
            <a
              @click.stop.prevent="cSideBar(8)"
              :class="{'active': articleid === 8}"
            >联系我们</a>
          </span>
        </li>
      </ul>

      <ul>
        <li class="help2_li2"><img
            src="//static.kxymall.com/images/help_line_bj.jpg"
            style="float:left;"
          />
        </li>
        <li class="help_li1"><span>版块介绍</span></li>
        <!-- 调用CMS数据搜索标签，并传递所在模型ID参数 -->
        <li>
          <span class="help_spans">
            <a
              @click.stop.prevent="cSideBar(9)"
              :class="{'active': articleid === 9}"
            >自营专区</a>
          </span>
        </li>
        <li>
          <span class="help_spans">
            <a
              @click.stop.prevent="cSideBar(10)"
              :class="{'active': articleid === 10}"
            >云优品服务站</a>
          </span>
        </li>
        <li>
          <span class="help_spans">
            <a
              @click.stop.prevent="cSideBar(11)"
              :class="{'active': articleid === 11}"
            >免费联盟商家</a>
          </span>
        </li>
        <li>
          <span class="help_spans">
            <a
              @click.stop.prevent="cSideBar(12)"
              :class="{'active': articleid === 12}"
            >菜篮子生活社区店</a>
          </span>
        </li>
        <li>
          <span class="help_spans">
            <a
              @click.stop.prevent="cSideBar(13)"
              :class="{'active': articleid === 13}"
            >入驻商家（非自营专区）</a>
          </span>
        </li>
        <li>
          <span class="help_spans">
            <a
              @click.stop.prevent="cSideBar(14)"
              :class="{'active': articleid === 14}"
            >邀请有奖</a>
          </span>
        </li>
      </ul>

      <ul>
        <li class="help2_li2"><img
            src="//static.kxymall.com/images/help_line_bj.jpg"
            style="float:left;"
          />
        </li>
        <li class="help_li1"><span>新手指南</span></li>
        <!-- 调用CMS数据搜索标签，并传递所在模型ID参数 -->
        <li>
          <span class="help_spans">
            <a
              @click.stop.prevent="cSideBar(15)"
              :class="{'active': articleid === 15}"
            >商城免费会员</a>
          </span>
        </li>
        <li>
          <span class="help_spans">
            <a
              @click.stop.prevent="cSideBar(16)"
              :class="{'active': articleid === 16}"
            >账户管理</a>
          </span>
        </li>
        <li>
          <span class="help_spans">
            <a
              @click.stop.prevent="cSideBar(17)"
              :class="{'active': articleid === 17}"
            >购物流程</a>
          </span>
        </li>
        <li>
          <span class="help_spans">
            <a
              @click.stop.prevent="cSideBar(18)"
              :class="{'active': articleid === 18}"
            >常见问题汇总</a>
          </span>
        </li>
      </ul>

      <ul>
        <li class="help2_li2"><img
            src="//static.kxymall.com/images/help_line_bj.jpg"
            style="float:left;"
          />
        </li>
        <li class="help_li1"><span>支付方式</span></li> <!-- 调用CMS数据搜索标签，并传递所在模型ID参数 -->
        <li>
          <span class="help_spans">
            <a
              @click.stop.prevent="cSideBar(19)"
              :class="{'active': articleid === 19}"
            >在线支付</a>
          </span>
        </li>
        <li>
          <span class="help_spans">
            <a
              @click.stop.prevent="cSideBar(20)"
              :class="{'active': articleid === 20}"
            >线下扫码</a>
          </span>
        </li>

      </ul>

      <ul>
        <li class="help2_li2"><img
            src="//static.kxymall.com/images/help_line_bj.jpg"
            style="float:left;"
          />
        </li>
        <li class="help_li1"><span>配送方式</span></li> <!-- 调用CMS数据搜索标签，并传递所在模型ID参数 -->
        <li>
          <span class="help_spans">
            <a
              @click.stop.prevent="cSideBar(21)"
              :class="{'active': articleid === 21}"
            >自营商品配送方式</a>
          </span>
        </li>
        <li>
          <span class="help_spans">
            <a
              @click.stop.prevent="cSideBar(22)"
              :class="{'active': articleid === 22}"
            >第三方商品配送方式</a>
          </span>
        </li>
      </ul>

      <ul>
        <li class="help2_li2"><img
            src="//static.kxymall.com/images/help_line_bj.jpg"
            style="float:left;"
          />
        </li>
        <li class="help_li1"><span>售后服务</span></li> <!-- 调用CMS数据搜索标签，并传递所在模型ID参数 -->
        <li>
          <span class="help_spans">
            <a
              @click.stop.prevent="cSideBar(23)"
              :class="{'active': articleid === 23}"
            >自营商品售后</a>
          </span>
        </li>
        <li>
          <span class="help_spans">
            <a
              @click.stop.prevent="cSideBar(24)"
              :class="{'active': articleid === 24}"
            >第三方商家商品售后</a>
          </span>
        </li>
      </ul>

      <ul>
        <li class="help2_li2"><img
            src="//static.kxymall.com/images/help_line_bj.jpg"
            style="float:left;"
          />
        </li>
        <li class="help_li1"><span>购物条款</span></li> <!-- 调用CMS数据搜索标签，并传递所在模型ID参数 -->
        <li>
          <span class="help_spans">
            <a
              @click.stop.prevent="cSideBar(25)"
              :class="{'active': articleid === 25}"
            >服务条款</a>
          </span>
        </li>
        <li>
          <span class="help_spans">
            <a
              @click.stop.prevent="cSideBar(26)"
              :class="{'active': articleid === 26}"
            >隐私政策</a>
          </span>
        </li>
        <li>
          <span class="help_spans">
            <a
              @click.stop.prevent="cSideBar(27)"
              :class="{'active': articleid === 27}"
            >交易纠纷处理规则</a>
          </span>
        </li>
        <li>
          <span class="help_spans">
            <a
              @click.stop.prevent="cSideBar(28)"
              :class="{'active': articleid === 28}"
            > 商家服务协议</a>
          </span>
        </li>
        <li>
          <span class="help_spans">
            <a
              @click.stop.prevent="cSideBar(29)"
              :class="{'active': articleid === 29}"
            > 联盟商家入驻服务协议</a>
          </span>
        </li>
      </ul>
      <ul class="help2_ul6"></ul>
    </div>
    <div
      class="help-right"
      v-if="!!articleContent"
      v-html="articleContent"
      style="padding:10px 20px;"
    >

    </div>
    <div
      class="help-right"
      v-if="!!!articleContent"
    >
      <!-- 关于我们 -->
      <div
        v-show="articleid === 7"
        class="client pt-2"
        style="margin-left:47px;"
      >
        <img
          src="../../assets/images/aboutUs/aboutUs01.jpg"
          style="width:88%;"
          alt=""
        >
      </div>
      <!-- 联系我们 -->
      <div
        v-show="articleid === 8"
        class="client pt-2"
        style="margin-left:47px;"
      >
        <img
          src="../../assets/images/aboutUs/aboutUs02.jpg"
          style="width:88%;"
          alt=""
        >
      </div>
      <!-- 自营专区 -->
      <div
        v-show="articleid === 9"
        class="client pt-2"
        style="margin-left:47px;"
      >
        <img
          src="../../assets/images/aboutUs/aboutUs03.jpg"
          style="width:88%;"
          alt=""
        >
      </div>
      <!-- 云优品服务站 -->
      <div
        v-show="articleid === 10"
        class="client pt-2"
        style="margin-left:47px;"
      >
        <img
          src="../../assets/images/aboutUs/aboutUs04.jpg"
          style="width:88%;"
          alt=""
        >
      </div>
      <!-- 免费联盟商家 -->
      <div
        v-show="articleid === 11"
        class="client pt-2"
        style="margin-left:47px;"
      >
        <img
          src="../../assets/images/aboutUs/aboutUs05.jpg"
          style="width:88%;"
          alt=""
        >
      </div>
      <!-- 菜篮子生活社区店 -->
      <div
        v-show="articleid === 12"
        class="client pt-2"
        style="margin-left:47px;"
      >
        <img
          src="../../assets/images/aboutUs/aboutUs06.jpg"
          style="width:88%;"
          alt=""
        >
      </div>
      <!-- 入驻商家（非自营专区） -->
      <div
        v-show="articleid === 13"
        class="client pt-2"
        style="margin-left:47px;"
      >
        <img
          src="../../assets/images/aboutUs/aboutUs07.jpg"
          style="width:88%;"
          alt=""
        >
      </div>
      <!-- 邀请有奖 -->
      <div
        v-show="articleid === 14"
        class="client pt-2"
        style="margin-left:47px;"
      >
        <img
          src="../../assets/images/aboutUs/aboutUs08.jpg"
          style="width:88%;"
          alt=""
        >
      </div>
      <!-- 商城免费会员 -->
      <div
        v-show="articleid === 15"
        class="client pt-2"
        style="margin-left:47px;"
      >
        <img
          src="../../assets/images/aboutUs/aboutUs09.jpg"
          style="width:88%;"
          alt=""
        >
      </div>
      <!-- 账户管理 -->
      <div
        v-show="articleid === 16"
        class="client pt-2"
        style="margin-left:47px;"
      >
        <img
          src="../../assets/images/aboutUs/aboutUs10.jpg"
          style="width:88%;"
          alt=""
        >
      </div>
      <!-- 购物流程 -->
      <div
        v-show="articleid === 17"
        class="client pt-2"
        style="margin-left:47px;"
      >
        <img
          src="../../assets/images/aboutUs/aboutUs11.jpg"
          style="width:88%;"
          alt=""
        >
      </div>
      <!-- 常见问题汇总 -->
      <div
        v-show="articleid === 18"
        class="client pt-2"
        style="margin-left:47px;"
      >
        <img
          src="../../assets/images/aboutUs/aboutUs12.jpg"
          style="width:88%;"
          alt=""
        >
      </div>
      <!-- 在线支付 -->
      <div
        v-show="articleid === 19"
        class="client pt-2"
        style="margin-left:47px;"
      >
        <img
          src="../../assets/images/aboutUs/aboutUs13.jpg"
          style="width:88%;"
          alt=""
        >
      </div>
      <!-- 线下扫码 -->
      <div
        v-show="articleid === 20"
        class="client pt-2"
        style="margin-left:47px;"
      >
        <img
          src="../../assets/images/aboutUs/aboutUs14.jpg"
          style="width:88%;"
          alt=""
        >
      </div>
      <!-- 自营商品配送方式 -->
      <div
        v-show="articleid === 21"
        class="client pt-2"
        style="margin-left:47px;"
      >
        <img
          src="../../assets/images/aboutUs/aboutUs15.jpg"
          style="width:88%;"
          alt=""
        >
      </div>
      <!-- 第三方商品配送方式 -->
      <div
        v-show="articleid === 22"
        class="client pt-2"
        style="margin-left:47px;"
      >
        <img
          src="../../assets/images/aboutUs/aboutUs16.jpg"
          style="width:88%;"
          alt=""
        >
      </div>
      <!-- 自营商品售后 -->
      <div
        v-show="articleid === 23"
        class="client pt-2"
        style="margin-left:47px;"
      >
        <img
          src="../../assets/images/aboutUs/aboutUs17.jpg"
          style="width:88%;"
          alt=""
        >
      </div>
      <!-- 第三方商家商品售后 -->
      <div
        v-show="articleid === 24"
        class="client pt-2"
        style="margin-left:47px;"
      >
        <img
          src="../../assets/images/aboutUs/aboutUs18.jpg"
          style="width:88%;"
          alt=""
        >
      </div>
      <!-- 服务条款 -->
      <div
        v-show="articleid === 25"
        class="client pt-2"
        style="margin-left:47px;"
      >
        <img
          src="../../assets/images/aboutUs/aboutUs19.jpg"
          style="width:88%;"
          alt=""
        >
      </div>
      <!-- 隐私政策 -->
      <div
        v-show="articleid === 26"
        class="client pt-2"
        style="margin-left:47px;"
      >
        <img
          src="../../assets/images/aboutUs/aboutUs20.jpg"
          style="width:88%;"
          alt=""
        >
        <img
          src="../../assets/images/aboutUs/aboutUs21.jpg"
          style="width:88%;"
          alt=""
        >
      </div>
      <!-- 交易纠纷处理规则 -->
      <div
        v-show="articleid === 27"
        class="client pt-2"
        style="margin-left:47px;"
      >
        <img
          src="../../assets/images/xieyi/jiaoyijiufen.jpg"
          style="width:88%;"
          alt=""
        >
      </div>
      <!-- 商家服务协议 -->
      <div
        v-show="articleid === 28"
        class="client pt-2"
        style="margin-left:47px;"
      >
        <img
          src="../../assets/images/xieyi/shangjia1.jpg"
          style="width:88%;"
          alt=""
        >
        <img
          src="../../assets/images/xieyi/shangjia2.jpg"
          style="width:88%;"
          alt=""
        >
        <img
          src="../../assets/images/xieyi/shangjia3.jpg"
          style="width:88%;"
          alt=""
        >
        <img
          src="../../assets/images/xieyi/shangjia4.jpg"
          style="width:88%;"
          alt=""
        >
      </div>
      <!-- 联盟商家入驻服务协议 -->
      <div
        v-show="articleid === 29"
        class="client pt-2"
        style="margin-left:47px;"
      >
        <img
          src="../../assets/images/xieyi/lianmeng1.jpg"
          style="width:88%;"
          alt=""
        >
        <img
          src="../../assets/images/xieyi/lianmeng2.jpg"
          style="width:88%;"
          alt=""
        >
        <img
          src="../../assets/images/xieyi/lianmeng3.jpg"
          style="width:88%;"
          alt=""
        >
        <img
          src="../../assets/images/xieyi/lianmeng4.jpg"
          style="width:88%;"
          alt=""
        >
      </div>
    </div>
  </div>
</template>

<script>
import { getArticleContent } from "api/home";
export default {
  name: "help",
  created() {
    if (!this.$route.query.articleid) {
      this.articleid = 7;
    } else {
      this.articleid = Number(this.$route.query.articleid);
    }
    // let query = this.$route.query || {};
    // if (query.articleid && query.new) {
    //   this.fetchData(query.articleid);
    // }
  },
  data() {
    return {
      articleid: 7,
      articleContent: false,
    };
  },
  watch: {
    // 如果路由有变化
    $route(to, from) {
      if (this.$route.path === "/help") {
        this.articleid =
          this.$route.query.articleid === undefined
            ? "7"
            : Number(this.$route.query.articleid);
      }
    },
  },
  methods: {
    cSideBar(articleid) {
      this.articleid = articleid;
      // 重新传参，避免刷新时重置显示默认
      this.$router.push({
        path: "/help",
        query: { articleid: this.articleid },
      });
    },
    fetchData(id) {
      getArticleContent(id).then((json) => {
        if (json.resCode == 1) {
          this.articleContent = json.data.content || "";
        }
      });
    },
  },
};
</script>
<style scoped>
@import "../../assets/css/help.css";
</style>



// WEBPACK FOOTER //
// help.vue?51e19d38